import React, { useState } from "react";
import Editor from "@monaco-editor/react";
import { transform } from "@babel/standalone";
import "./App.css";

function App() {
  const [code, setCode] = useState(
    `// Write your JavaScript/React code here\nconsole.log("Hello, World!");`
  );
  const [output, setOutput] = useState("");

  const handleRunCode = () => {
    try {
      // Transpile JSX to JavaScript (if needed)
      const transpiledCode = transform(code, {
        presets: ["react"],
      }).code;

      // Capture console.log output
      let consoleOutput = "";
      const originalConsoleLog = console.log;
      console.log = (message) => {
        consoleOutput += message + "\n";
      };

      // Execute the code
      eval(transpiledCode);

      // Restore original console.log
      console.log = originalConsoleLog;

      // Display the output
      setOutput(consoleOutput);
    } catch (error) {
      setOutput(`Error: ${error.message}`);
    }
  };

  return (
    <div className="app-container">
      {/* Header */}
      <div className="header">
        <h1 className="title">Web Code Editor</h1>
        <button className="run-button" onClick={handleRunCode}>
          Run Code
        </button>
      </div>

      {/* Editor and Output Panels */}
      <div className="editor-output-container">
        {/* Editor Panel */}
        <div className="editor-panel">
          <Editor
            height="100%"
            defaultLanguage="javascript"
            value={code}
            onChange={(newValue) => setCode(newValue)}
            theme="vs-dark"
            options={{
              automaticLayout: true,
              minimap: { enabled: false },
            }}
          />
        </div>

        {/* Output Panel */}
        <div className="output-panel">
          <h2 className="output-title">Output</h2>
          <pre className="output-box">{output}</pre>
        </div>
      </div>
    </div>
  );
}

export default App;
